<template>
  <div>
    <q-dialog
      :visible.sync="dialogVisible"
      title="新增"
      width="960px"
      :append-to-body="true"
      @cancel="updateVal"
      @confirm="confirm"
      @close="updateVal"
    >
      <!-- // 业务 -->
      <el-row type="flex" justify="space-between">
        <div>文件名：{{rowData.fileName}}</div>
      </el-row>
      <el-row type="flex" justify="space-between" align="middle">
        <el-form :model="formData" :inline="true" size="mini" style="margin-top: 10px;">
          <el-form-item label="SPU名称">
            <el-input v-model.trim="formData.spuName"></el-input>
          </el-form-item>
          <el-form-item>
            <el-button type="" @click="reset">重置</el-button>
            <el-button type="primary" @click="search">搜索</el-button>
          </el-form-item>
        </el-form>
        <div>
          <span style="margin-right: 10px;">更新说明</span>
          <el-input v-model.trim="updateDesc" size="mini" style="width: 150px;"></el-input>
        </div>
      </el-row>
      <el-row :gutter="10" style="width: 100%;">
        <el-col :span="10">
          <span style="color: #999;">待选列表</span>
          <el-table
            :data="tableData"
            border
            :height="300"
            style="margin-top: 10px;"
            v-loading="loading"
          >
            <el-table-column label="SPU编码" prop="spuCode"></el-table-column>
            <el-table-column label="SPU名称" prop="spuName" show-overflow-tooltip></el-table-column>
            <el-table-column label="操作" width="70px">
              <template slot-scope="scope">
                <el-button type="text"  @click="onAdd(scope.row)" v-if="tableData2.findIndex(v=>v.spuId === scope.row.spuId) === -1">添加</el-button>
                <el-button type="text" disabled v-else>已添加</el-button>
              </template>
            </el-table-column>
          </el-table>
          <div style="text-align: right; margin-top: 10px;">
            <el-pagination
              @size-change="handleSizeChange"
              @current-change="handleCurrentChange"
              :current-page="paginationOpt.pageNum"
              :page-sizes="paginationOpt.pageSizes"
              :page-size="paginationOpt.pageSize"
              layout="total, prev, pager, next"
              :total="paginationOpt.total">
            </el-pagination>
          </div>
        </el-col>
        <el-col :span="4" style="text-align: center; margin-top: 160px;">
          <el-button type="" icon="el-icon-d-arrow-left"></el-button>
          <el-button type="" icon="el-icon-d-arrow-right"></el-button>
        </el-col>
        <el-col :span="10">
          <span style="color: #999;">已选列表</span>
          <el-table
            :data="tableData2"
            border
            :height="300"
            style="margin-top: 10px;"
          >
            <el-table-column label="SPU名称" prop="spuName" show-overflow-tooltip></el-table-column>
            <el-table-column label="更新说明" prop="instruction">
              <template slot-scope="scope">
                <el-input v-model="scope.row.instruction"></el-input>
              </template>
            </el-table-column>
            <el-table-column label="操作" width="60px">
              <template slot-scope="scope">
                <el-button type="text" @click="onRemove(scope.row)">移除</el-button>
              </template>
            </el-table-column>
          </el-table>
        </el-col>
      </el-row>
    </q-dialog>
  </div>
</template>

<script>
import axios from '@/utils/axiosInstance'
export default {
  model: {
    prop: 'visible',
    event: 'input'
  },
  props: ['visible', 'data', 'dataType'],
  data() {
    return {
      loading: false,
      updateDesc: '',
      formData: {},
      tableData: [],
      tableData2: [],
      paginationOpt: {
        pageSizes: [30, 60, 90],
        pageSize: 30,
        pageNum: 1,
        total: 0
      },
    }
  },
  computed: {
    dialogVisible: {
      get() {
        return this.visible
      },
      set(val) {
        this.$emit('update:visible', val)
      },
    },
    rowData() {
      return this.data;
    }
  },
  mounted() {
    this.updateDesc = this.rowData.spuInfo.length && this.rowData.spuInfo[0].instruction || '';
    this.init();
  },
  methods: {
    updateVal() {
      this.dialogVisible = false;
      if (this.isNeedRefresh) {
        this.$emit('success');
      }
      this.$emit('close');
    },
    confirm() {
      let data = {
        fileId: this.rowData.fileId,
        productDataType: this.dataType,
        spuIds: this.tableData2.map(v=>{
          return {
            spuId: String(v.spuId),
            instruction: v.instruction
          }
        })
      }
      this.$q.newProduct.updateSpuBom({data})
      .then(res=>{
        if(res.code == 200) {
          this.$message.success('新增成功')
        }else{
          this.$message.error(res.message)
        }
        this.$bus.$emit('closeAll')
      })
    },
    reset() {
      this.formData = {};
      this.paginationOpt.pageNum = 1;
      this.init();
    },
    search() {
      this.paginationOpt.pageNum = 1;
      this.init();
    },
    // 分页器 pagesize
    handleSizeChange(val) {
      this.paginationOpt.pageSize = val;
      this.paginationOpt.pageNum = 1;
      this.init();
    },
    // 分页器 pageNum
    handleCurrentChange(val) {
      this.paginationOpt.pageNum = val;
      this.init();
    },
    /**
     * 待选列表搜索
     */
    init() {
      this.loading = true;
      let formData = {
        pageSize: this.paginationOpt.pageSize,
        pageNum: this.paginationOpt.pageNum,
        filterData: {
          ...this.formData,
          dataType: this.dataType,
          fileId:this.rowData.fileId
        }
      };
      this.$q.newProduct.getSpuBomPage({data: formData})
      .then(res=>{
        this.tableData = res.data.records;
        this.paginationOpt['total'] = res.data.total;
      })
      .finally(_=>{
        this.loading = false;
      })
    },
    /**
     * 添加&移除
     */ 
    onAdd(row) {
      row = JSON.parse(JSON.stringify(row))
      if(!this.tableData2.find(v=>v.spuId == row.spuId)) {
        this.$set(row, 'instruction', this.updateDesc);
        this.tableData2.push(row)
        // let index = this.tableData.findIndex(item=>item.spuId===row.spuId)
        // if(index>-1){
        //   this.tableData.splice(index,1)
        // }
      }
    },
    onRemove(row) {
      //this.tableData2 = this.tableData2.filter(v=>v.spuId !== row.spuId);
      row = JSON.parse(JSON.stringify(row))
      if(!this.tableData.find(v=>v.spuId == row.spuId)){
        this.tableData2 = this.tableData2.filter(v=>v.spuId !== row.spuId);
        this.tableData.push(row)
      }else{
        this.tableData2 = this.tableData2.filter(v=>v.spuId !== row.spuId);
      }
    }
  }
}
</script>

<style lang="stylus" scoped>
</style>
